<template>
  <div id="TTT">
    <bg-video ref="bv" filename="3D" :autoplay="false" @ended="showDetail = true"/>
    <img class="des" src="./img/5-1-1.png" alt="des">
    <div v-show="showDetail" class="details" :class="bgi">
      <dot :style="{ top: '1.4rem', left: '4.3rem' }" text="主体建筑" @click.native="checkDetail(2)"/>
      <dot :style="{ top: '2.3rem', left: '6.2rem' }" text="隧道入口" @click.native="checkDetail(5)"/>
      <dot :style="{ top: '3.1rem', left: '8.1rem' }" text="环岛公路" @click.native="checkDetail(4)"/>
      <dot :style="{ top: '5.3rem', left: '6.8rem' }" text="防波堤" @click.native="checkDetail(3)"/>
      <dot :style="{ top: '7rem', left: '7.5rem' }" text="钢圆筒" @click.native="checkDetail(6)"/>
      <guide-button class="btn-rt" @click.native="$emit('close')">继续</guide-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TTT',
  data () {
    return {
      showDetail: false,
      bgi: '',
    }
  },
  mounted () {
    this.$bgAudio.play()
  },
  beforeDestroy () {
    this.$bgAudio.pause()
  },
  methods: {
    checkDetail (index) {
      this.bgi = `bg-${index}`
    },
    play () {
      this.$refs.bv.play()
    },
  },
}
</script>

<style lang="scss" scoped>
#TTT,
.details {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 19.2rem;
  height: 10.8rem;
  z-index: 3;
}
.des {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.details {
  z-index: 4;
  @for $i from 1 to 7 {
    &.bg-#{$i} {
      background-image: url(./img/5-1-#{$i}.png);
    }
	}
  background-size: 100% 100%;
}
</style>
